<template>
  <DatePicker
    class="datepicker-component"
    :input-class="`datepicker-input ${inputClass}`"
    :wrapper-class="`datepicker-wrapper ${wrapperClass}`"
    :open-date="currentDate"
    :disabled-dates="disabledDate"
    :language="language"
    :format="dateFormat"
    :full-month-name="true"
    @selected="selectedDate"
    v-bind="$attrs"
  />
</template>

<script>
import DatePicker from 'vuejs-datepicker-thai'
import { th } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
  name: 'DatePickerComponent',
  data: () => ({
    currentDate: moment()
      .toDate(),
    disabledDate: {
      to: '',
      from: '',
    },
  }),
  props: {
    inputClass: {
      type: String,
      default: '',
    },
    wrapperClass: {
      type: String,
      default: '',
    },
    dateFormat: {
      type: String,
      default: 'dd/MM/yyyy',
    },
    language: {
      type: Object,
      default: () => th,
    },
    type: String,
  },
  components: { DatePicker },
  mounted() {
    const today = moment()
      .subtract(1, 'days')
      .toDate()
    const oneMonthBehind = moment()
      .subtract(1, 'months')
      .toDate()
    const oneMonthAhead = moment()
      .add(1, 'months')
      .toDate()

    if (this.type === 'birthday') {
      this.disabledDate = {
        to: '',
        from: oneMonthBehind,
      }
    } else if (this.type === 'effective_date') {
      this.disabledDate = {
        to: today,
        from: oneMonthAhead,
      }
    } else if (this.type === 'past') {
      this.disabledDate = {
        to: '',
        from: today,
      }
    }
  },
  methods: {
    selectedDate(val) {
      this.$emit('input', moment(val).format('YYYY-MM-DD'))
    },
  },
}
</script>

<style lang="scss">
.datepicker-input {
  &:read-only {
    background-color: #fff;
  }

  &:disabled {
    background-color: #eee;
  }
}
</style>
